import { evalCondition, STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import {
  beMessApiCopyHtmlMessage,
  beMessApiCopyMessage,
  beMessApiGetActiveMessage,
  beMessApiGetEntitiesThatUseMessage,
  beMessApiSetActiveMessageOfType,
  beMessApiUpdateMessage,
  beMessCheckSetMessageTypes,
  beMessGetMessageContent,
  beMessGetMessageDetails,
  beMessSetMessageTypes
} from 'Api/BeMessApi'
import { beEmailCheckupFastMessageCheck } from 'Api/beEmailCheckupApi'
import { beSendGoCheckSendingProgress } from 'Api/beSendGoApi'

import {
  BeListApiAddNewTag,
  BeListApiGetAllTags,
  BeListApiSetWelcomeMessage,
  beListGetMandatorySender,
  beListGetTrackingInfoCustomParams,
  beListInitMandatorySenderWithAnagraphicData
} from 'Api/BeListApi'
import {
  beAutomationApiSearchWorkflowByTypeAndStatus,
  beAutomationApiUpdateWelcomeSeries
} from 'Api/beAutomationApi'
import { bePubCustomCreateLandingPages } from 'Api/bePubCustomApi'
import { campaignsBuilderGetEmailCampaignByIdMessage } from 'Api/campaignsBuilderApi'
import {
  ENTITY_TYPE_AUTOMATION_WORKFLOW,
  ENTITY_TYPE_TRIGGER,
  MESSAGE_ATTACHMENT_ALLOWED_EXT,
  MESSAGE_MAX_ATTACHMENTS,
  MESSAGE_MAX_ATTACHMENTS_SIZE_KB,
  WORKFLOW_STR_STATUS_ALL,
  WORKFLOW_STR_TYPE_WELCOME_SERIES
} from 'Constants'

import {
  beEmailMessageApiCreateMessageThumbnail,
  beEmailMessageApiGetEntitiesThatUseMessage,
  beEmailMessageApiGetFolderContentMetadata,
  beEmailMessageApiGetMessageHtmlExport,
  beEmailMessageApiGetMessagePdfExport,
  beEmailMessageApiSetAttachmentsConfiguration
} from 'Api/beEmailMessageApi'

import { fspApiDownloadAttachment, fspApiUploadAttachment } from 'Api/fspApi'

import {
  bePersonalizationApiGetEndpointsAttachToList,
  bePersonalizationApiGetEndpointsAttachToMessage,
  bePersonalizationApiGetEndpointsList,
  bePersonalizationApiSaveEndpointsAttachToMessage
} from 'Api/bePersonalizationApi'
import {
  beRecipientGetDynamicFileds,
  beRecipientGetDynamicFiledsListValue
} from 'Api/beRecipientApi'
import filterObject from 'Helpers/filterObject'

import {
  beAccountSettingsAddSilencedAlerts,
  beAccountSettingsGetSilencedAlerts,
  beAccountSettingsGetUserSetting,
  beAccountSettingsUpsertUserSettings
} from 'Api/beAccountSettingsApi'
import { beAsyncTrackingApiCheckTrackingDomainIsCustomizable } from 'Api/beAsyncTracking'
import {
  CUSTOM_DOMAIN_CUSTOMIZABLE,
  CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
} from 'Constants/index'
import getIntl from 'Helpers/intl'

const attachmentFilenameRe = /^\d+\/(.*)/

export async function getMessageDetails(idMessage) {
  const { Attachments, ...messageDetails } = await beMessGetMessageDetails(
    idMessage
  )

  const attachmentNames = Attachments.filter(o => !!o).map(filename => {
    const m = filename.match(attachmentFilenameRe)
    return m ? m[1] : filename
  })

  return { ...messageDetails, attachmentNames }
}

export async function isSendingMessage(idMessage) {
  const { Value } = await beSendGoCheckSendingProgress(idMessage)
  return Value
}

export async function checkImages(idMessage) {
  const checks = {
    Checks: ['Images']
  }

  const { CheckImages } = await beEmailCheckupFastMessageCheck(
    idMessage,
    checks
  )

  return CheckImages
}

export async function getEntitiesThatUseMessage(idMessage) {
  const entities = await beMessApiGetEntitiesThatUseMessage(idMessage)

  const workflows = entities.filter(
    ({ Type }) =>
      Type === ENTITY_TYPE_TRIGGER || Type === ENTITY_TYPE_AUTOMATION_WORKFLOW
  )
  return workflows.length > 0
}

export async function modalCheck(idMessage) {
  const checks = {
    Checks: [
      'Size',
      'MaxSize',
      'Attachments',
      'DynamicContents',
      'LinksWoTracking',
      'UnsubscribeLink',
      'Fields',
      'Preheader',
      'WebAnalytics',
      'LiquidCode',
      'Links',
      'Content'
    ]
  }

  const checkObj = await beEmailCheckupFastMessageCheck(idMessage, checks)

  let domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  try {
    const resultDomainIsCustomizable = await beAsyncTrackingApiCheckTrackingDomainIsCustomizable()
    const domainIsCustomizableOermission = evalCondition(
      'uo:GEST AND uo:SETTINGS'
    )
    if (resultDomainIsCustomizable && domainIsCustomizableOermission) {
      domainCustomizableStatus = resultDomainIsCustomizable.IsCustomizable
    }
  } catch (error) {
    domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  }

  checkObj.CustomDomainCustomizable =
    domainCustomizableStatus === CUSTOM_DOMAIN_CUSTOMIZABLE

  return checkObj
}

export async function fastCheck(idMessage) {
  const checks = {
    Checks: [
      'Size',
      'MaxSize',
      'Attachments',
      'DynamicContents',
      'LinksWoTracking',
      'UnsubscribeLink',
      'Fields',
      'Preheader',
      'WebAnalytics',
      'LiquidCode',
      'Links',
      'Content'
    ]
  }

  const {
    CheckLiquidCode,
    CheckAttachments,
    CheckDynamicContents,
    CheckSize,
    CheckBlacklistResult,
    CheckLinksWoTracking,
    CheckUnsubscribeLink,
    CheckFields,
    CheckMaxSize,
    CheckPreheader,
    CheckWebAnalytics,
    CheckContent
  } = await beEmailCheckupFastMessageCheck(idMessage, checks)

  let domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  try {
    const resultDomainIsCustomizable = await beAsyncTrackingApiCheckTrackingDomainIsCustomizable()
    const domainIsCustomizableOermission = evalCondition(
      'uo:GEST AND uo:SETTINGS'
    )
    if (resultDomainIsCustomizable && domainIsCustomizableOermission) {
      domainCustomizableStatus = resultDomainIsCustomizable.IsCustomizable
    }
  } catch (error) {
    domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  }

  const entities = await beMessApiGetEntitiesThatUseMessage(idMessage)

  const workflows = entities.filter(
    ({ Type }) =>
      Type === ENTITY_TYPE_TRIGGER || Type === ENTITY_TYPE_AUTOMATION_WORKFLOW
  )

  const wrongDynamicTags = CheckFields.WrongDynamicTags.map(({ Value }) =>
    Value.replace(/[[\]]/g, '')
  ).filter(f => f !== '')

  const blocking =
    Number(!CheckLiquidCode) +
    Number(!CheckAttachments.Check) +
    Number(!CheckDynamicContents.Check) +
    Number(!CheckSize.Check) +
    Number(CheckBlacklistResult.Action === 2) +
    Number(CheckContent.Action === 2)

  const potential =
    Number(!CheckLinksWoTracking) +
    Number(!CheckUnsubscribeLink) +
    Number(!CheckMaxSize.Check) +
    Number(CheckBlacklistResult.Action === 1) +
    Number(wrongDynamicTags.length > 0) +
    Number(workflows.length > 0)

  const improvements =
    Number(!CheckPreheader) +
    Number(!CheckWebAnalytics) +
    Number(domainCustomizableStatus === CUSTOM_DOMAIN_CUSTOMIZABLE)

  return {
    blocking,
    potential,
    improvements
  }
}

export async function getCampaignsInfo(idMessage) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const campaign = await campaignsBuilderGetEmailCampaignByIdMessage(
    idMessage,
    idList
  )

  return campaign
}

export async function copyMessage(idMessage, notes) {
  const result = await beMessApiCopyMessage(idMessage, notes)

  return result
}

export async function copyHtmlMessage(idMessage, notes) {
  const result = await beMessApiCopyHtmlMessage(idMessage, notes)

  return result
}

export async function validateMessageType(idMessage, messageType) {
  const result = await beMessCheckSetMessageTypes(idMessage, messageType)

  return result
}

export async function setWelcomeMessage() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  await BeListApiSetWelcomeMessage(idList, true)
}

export async function setMessageType(idMessage, messageType) {
  await beMessSetMessageTypes(idMessage, messageType)
}

export async function setActiveMessageOfType(idMessage, messageType) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  await beMessApiSetActiveMessageOfType(idList, idMessage, messageType)
}

export async function getRequiresUpdateWelcomeSeries() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const data = {
    Status: WORKFLOW_STR_STATUS_ALL,
    Type: WORKFLOW_STR_TYPE_WELCOME_SERIES
  }

  const result = await beAutomationApiSearchWorkflowByTypeAndStatus(
    idList,
    data
  )

  return result.Items.length > 0
}

export async function updateWelcomeSeries(idMessage) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  await beAutomationApiUpdateWelcomeSeries(idList, idMessage)
}

export async function createLandingPages(idMessage) {
  const result = await bePubCustomCreateLandingPages(idMessage)
  return result
}

export async function getAllTags() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await BeListApiGetAllTags(idList)
  return result
}

export async function addNewTag(pTagName) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await BeListApiAddNewTag(idList, pTagName)
  return result
}

export async function updateMessage(
  idMessage,
  {
    subject,
    preHeader,
    notes,
    tags,
    embed,
    useDynamicField,
    fields,
    customParams,
    trackingInfoEnabled,
    trackingInfoProtocols
  }
) {
  const current = await beMessGetMessageDetails(idMessage)

  const trackingInfo = {
    CustomParams: customParams,
    Enabled: trackingInfoEnabled,
    Protocols: trackingInfoProtocols
  }

  const updatedMessage = {
    ...filterObject(
      [
        'Content',
        'Structure',
        'Embed', // ok -- ok
        'UseDynamicField', // ok -- ok
        'PreHeader', // ok -- ok
        'TrackingInfo', // ok -- ok
        'Fields', // ok -- ok
        'Tags', // ok -- ok
        'IsArchived',
        'ShowOnline',
        'ServiceType',
        'PlainText',
        'IdList', // ok -- default
        'IdMessage', // ok -- default
        'Subject', // ok -- ok
        'Notes', // ok -- ok
        'CreationDate',
        'UpdateDate' // ??
      ],
      current
    ),
    Subject: subject,
    PreHeader: preHeader,
    Notes: notes,
    Tags: tags,
    Embed: embed,
    UseDynamicField: useDynamicField,
    Fields: fields,
    TrackingInfo: trackingInfo
  }
  const result = await beMessApiUpdateMessage(idMessage, updatedMessage)

  // pendo track selected emoji
  // const emoji = getEmojiCatalog(EMOJI_CATEGORIES)
  // let catalog = []
  // if (emoji.lenght > 0) {
  //   catalog = getEmojiCatalog(EMOJI_CATEGORIES).map(({ emoji }) => emoji)
  // }
  // const selectedEmoji = catalog.filter(emoji => subject.includes(emoji))

  // pendoTrack('Messages - Emoji selection - Save', {
  //   idMessage: idMessage,
  //   source: 'emailMessageOverview',
  //   emoji: selectedEmoji.join(',')
  // })
  //

  return result
}

export const getActiveMessage = messageType => {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  return beMessApiGetActiveMessage(idList, messageType)
}

export async function updateMessageDynamicFields(idMessage, { fields }) {
  const current = await beMessGetMessageDetails(idMessage)

  const updatedMessage = {
    ...filterObject(
      [
        'Content',
        'Structure',
        'Embed',
        'UseDynamicField',
        'PreHeader',
        'TrackingInfo',
        'Fields',
        'Tags',
        'IsArchived',
        'ShowOnline',
        'ServiceType',
        'PlainText',
        'IdList',
        'IdMessage',
        'Subject',
        'Notes',
        'CreationDate',
        'UpdateDate'
      ],
      current
    ),
    Fields: fields
  }
  const result = await beMessApiUpdateMessage(idMessage, updatedMessage)
  return result
}

export async function updateEndpoints(idMessage, contentEndpointIds) {
  const hasPersonalization = evalCondition('co:ADVPERSONALIZATION')

  const result = hasPersonalization
    ? await bePersonalizationApiSaveEndpointsAttachToMessage(
        idMessage,
        contentEndpointIds
      )
    : undefined

  return result
}

export async function getMessageContent(idMessage) {
  const result = await beMessGetMessageContent(idMessage)
  return result
}

export async function getTrackingInfoCustomParams() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beListGetTrackingInfoCustomParams(idList)
  return result
}

export async function getDynamicFields() {
  const result = await beRecipientGetDynamicFileds()
  return result
}

export async function getDynamicFieldsListValue() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beRecipientGetDynamicFiledsListValue(idList)
  return result
}

export async function getEndpointsList() {
  const result = await bePersonalizationApiGetEndpointsList()
  return result
}

export async function getEndpointsAttachToList() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await bePersonalizationApiGetEndpointsAttachToList(idList)
  return result
}

export async function getEndpointsAttachToMessage(idMessage) {
  const hasPersonalization = evalCondition('co:ADVPERSONALIZATION')

  const result = hasPersonalization
    ? await bePersonalizationApiGetEndpointsAttachToMessage(idMessage)
    : { Items: [] }
  return result
}

export async function getAttachmentsInfo(idMessage) {
  const { Items } = await beEmailMessageApiGetFolderContentMetadata(idMessage)
  return Items
}

export async function updateAttachmentsConfiguration(
  idMessage,
  newAttachments
) {
  const result = await beEmailMessageApiSetAttachmentsConfiguration(
    idMessage,
    newAttachments
  )
  return result
}

export async function downloadAttachment(idMessage, fileName) {
  const result = await fspApiDownloadAttachment(idMessage, fileName)
  return result
}

export const validateAttachments = (newFiles, currentAttachments) => {
  const currentSize = currentAttachments.reduce(
    (acc, { size }) => acc + size,
    0
  )

  /* check filename and filter  */
  const validFilename = newFiles.filter(({ name }) =>
    currentAttachments.every(
      ({ name: existing }) => name.toLowerCase() !== existing.toLowerCase()
    )
  )

  const conflicting = newFiles.filter(({ name }) =>
    currentAttachments.some(
      ({ name: existing }) => name.toLowerCase() === existing.toLowerCase()
    )
  )

  const wrongFilename = newFiles.length !== validFilename.length

  const conflictingFilename = wrongFilename ? conflicting[0].name : undefined

  /* check file extension and filter */
  const validExt = validFilename.filter(({ name }) =>
    MESSAGE_ATTACHMENT_ALLOWED_EXT.some(ext =>
      name.toLowerCase().endsWith(ext.toLowerCase())
    )
  )

  const wrongExt = validFilename.length !== validExt.length

  /* check single file size and filter */
  const validSingleSize = validExt.filter(
    ({ size }) => size / 1024 <= MESSAGE_MAX_ATTACHMENTS_SIZE_KB
  )

  const wrongSingleSize = validSingleSize.length !== validExt.length

  /* check total size and total file count */
  const newSizePreview = validSingleSize.reduce(
    ({ prog, toUpload }, { name, size }) => {
      const newProg = prog + size / 1024
      const newProgOk = newProg <= MESSAGE_MAX_ATTACHMENTS_SIZE_KB
      const canUpload =
        newProgOk &&
        currentAttachments.length + toUpload.length < MESSAGE_MAX_ATTACHMENTS

      return {
        prog: newProg,
        toUpload: [...toUpload, ...(canUpload ? [name] : [])]
      }
    },
    { prog: currentSize, toUpload: [] }
  )

  const newAttachments = newFiles.filter(({ name }) =>
    newSizePreview.toUpload.includes(name)
  )

  return {
    wrongFilename,
    wrongExt,
    wrongSingleSize,
    wrongTotalSize: newSizePreview.prog > MESSAGE_MAX_ATTACHMENTS_SIZE_KB,
    wrongTotalCount:
      currentAttachments.lenght + newAttachments.length >
      MESSAGE_MAX_ATTACHMENTS,
    newAttachments,
    conflictingFilename
  }
}

export const readFileAsBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () =>
      resolve(reader.result.match(/^data:[^;]+;base64,(.*)$/)[1])
    reader.onerror = error => reject(error)
  })
}

export async function uploadAttachment(idMessage, file) {
  const content = await readFileAsBase64(file)
  const result = await fspApiUploadAttachment(idMessage, {
    FileName: file.name,
    FileContent: content
  })
  return result
}

export const getUploadFeedback = ({
  wrongFilename,
  wrongExt,
  wrongSingleSize,
  wrongTotalSize,
  wrongTotalCount,
  conflictingFilename
}) => {
  if (wrongFilename) {
    return getIntl().formatMessage(
      {
        id: 'Load.EmailMessageImport.fileUploaderDuplicateSingleFile'
      },
      {
        strong: chunks => <strong key='filename'>{chunks}</strong>,
        FILENAME: conflictingFilename
      }
    )
  } else if (wrongExt) {
    return getIntl().formatMessage({
      id: 'Load.SavedEmailWizard.AttachmentUploadWrongFormat'
    })
  } else if (wrongSingleSize) {
    return getIntl().formatMessage(
      {
        id: 'Load.SavedEmailWizard.AttachmentUploadSizeLimit'
      },
      {
        MAXSIZE: '7 MB (7000 KB)'
      }
    )
  } else if (wrongTotalSize) {
    return getIntl().formatMessage(
      {
        id: 'Load.SavedEmailWizard.MaxCumulativeUploadSize'
      },
      { MAXSIZE: '7 MB (7000 KB)' }
    )
  } else if (wrongTotalCount) {
    return getIntl().formatMessage({
      id: 'Load.SavedEmailWizard.UploadFileLimit'
    })
  }
}

export async function getSilencedAlerts() {
  const idList = 0 // parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsGetSilencedAlerts(idList)
  return result || {}
}

export async function getWhitelist(idMessage) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsGetUserSetting(
    idList,
    `whiteListDynamicField-NL-${encodeURIComponent(idMessage)}`
  )
  return result || {}
}

export async function updateWhitelist(idMessage, DataValue) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsUpsertUserSettings(
    idList,
    `whiteListDynamicField-NL-${encodeURIComponent(idMessage)}`,
    DataValue
  )
  return result || {}
}

export async function addSilencedAlerts(DataValue) {
  const idList = 0 // parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsAddSilencedAlerts(idList, DataValue)
  return result || {}
}

export async function getMandatorySenderAction() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beListGetMandatorySender(idList)
  return result
}

export async function initMandatorySenderWithAnagraphicDataAction() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beListInitMandatorySenderWithAnagraphicData(idList)
  return result
}

export async function checkMessageIsUsed(idMessage) {
  const entities = await beEmailMessageApiGetEntitiesThatUseMessage(idMessage)

  return entities.length > 0
}

export async function getFormListUsingMessage(idMessage) {
  const formTypes = ['SubscriptionForm', 'LandingPage', 'SubscriptionFormPopUp']

  const entities = await beEmailMessageApiGetEntitiesThatUseMessage(idMessage)

  return entities.filter(e => formTypes.includes(e.Type))
}

export const getLinkedEntities = async idMessage => {
  const formTypes = ['SubscriptionForm', 'LandingPage', 'SubscriptionFormPopUp']

  const entities = await beEmailMessageApiGetEntitiesThatUseMessage(idMessage)

  return {
    forms: entities.filter(e => formTypes.includes(e.Type)),
    entities
  }
}

export async function getWelcomeSeries() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const data = {
    Status: 'All',
    Type: 'WelcomeSeries',
    SearchText: '',
    TagIds: [],
    IdMessagesEmail: [],
    IdMessagesSms: []
  }

  const result = await beAutomationApiSearchWorkflowByTypeAndStatus(
    idList,
    data
  )

  return result && result.TotalItems > 0
}

export async function getMessageHtmlExport(idMessage) {
  const res = await beEmailMessageApiGetMessageHtmlExport(idMessage)

  return res
}

export async function getMessagePdfExport(idMessage) {
  const res = await beEmailMessageApiGetMessagePdfExport(idMessage)

  return res
}

export async function getScreenshot(idMessage) {
  await beEmailMessageApiCreateMessageThumbnail(idMessage)
}

export const getRouteForFirstEntity = entities => {
  if (Array.isArray(entities) && entities.length > 0) {
    switch (entities[0].Type) {
      case 'SubscriptionForm':
        return `/databasebuilding/engagement/${entities[0].Id}/edit`

      case 'LandingPage':
        return `/databasebuilding/landingpage/${entities[0].Id}/settings`

      case 'SubscriptionFormPopUp':
        return `/databasebuilding/multichannel/edit/${entities[0].Id}`
    }
  }
}
